__turbopack_context__.v({
  "content": "collections-pane-module-scss-module__zko6ZW__content",
  "header": "collections-pane-module-scss-module__zko6ZW__header",
  "pagination": "collections-pane-module-scss-module__zko6ZW__pagination",
  "root": "collections-pane-module-scss-module__zko6ZW__root",
  "tabsBar": "collections-pane-module-scss-module__zko6ZW__tabsBar",
  "title": "collections-pane-module-scss-module__zko6ZW__title",
});
